module.exports = __webpack_public_path__ + "img/pr-5.f0d7c55d.png";